<template>
    <v-container fluid >
        <Formulario :getParams="this.params"></Formulario>
    </v-container>
</template>

<script>
const Formulario = () => import("./components/Formulario.vue");
import Auth from "@/services/auth";
export default {
    name: "CursosNuevo",
    data() {
        return {
            permisos: [],
            loading: true,
            params: {
                curso_id: null,
                permisos: []
            }
        }
    },
    components: {
        Formulario
    },
    methods: {
        regresar() {
            this.$router.go(-1)
        }
    },
    created() {
        Auth.checkPermisos("/cursos/aprobados").then((res) => {
            this.permisos = res;

            if(!this.permisos[2]) {
                this.regresar();
            }

            this.params.permisos = this.permisos;

        });
    }
}
</script>

<style>

</style>
